import { Link, useParams } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { APP_CONFIG } from '@/config/app';
import { useAuth } from '@/hooks/useAuth';

/**
 * A staff session is in this browser. The portal shares the auth storage, so
 * we never auto-sign anyone out; the staff member chooses.
 */
export default function PortalStaffBlocked() {
  const { slug = '' } = useParams<{ slug: string }>();
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen bg-muted flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardContent className="pt-8 pb-8">
          <ShieldAlert className="mx-auto mb-4 h-12 w-12 text-warning" />
          <h1 className="mb-2 text-lg font-semibold">You're signed in as staff</h1>
          <p className="text-sm text-muted-foreground">
            This is the customer portal. You're currently signed in to {APP_CONFIG.name} with a staff account,
            so the portal can't show you a customer's view. Sign out here to use the portal, or go back to the dashboard.
          </p>
          <div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row">
            <Button asChild variant="outline">
              <Link to="/dashboard">Back to dashboard</Link>
            </Button>
            <Button onClick={() => void signOut({ redirectTo: `/portal/${slug}` })}>
              Sign out to use the portal
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
